var _circle, _path, _rect, _rect2, _rect3, _rect4, _g, _rect5, _rect6, _rect7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCtaCommunities = function SvgCtaCommunities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 109,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F7F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    d: "M41.714 8C38.558 8 36 10.377 36 13.31v35.048c0 2.933 2.558 5.31 5.714 5.31h31.429L82 60.571v-6.903h7.714c3.156 0 5.715-2.377 5.715-5.31V13.31c0-2.933-2.559-5.31-5.715-5.31h-48Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49.143,
    height: 3.429,
    x: 41.143,
    y: 25.714,
    fill: "#707780",
    rx: 1.714
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 49.143,
    height: 3.429,
    x: 41.143,
    y: 33.714,
    fill: "#707780",
    rx: 1.714
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 49.143,
    height: 3.429,
    x: 41.143,
    y: 41.714,
    fill: "#707780",
    rx: 1.714
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 3.429,
    x: 41.714,
    y: 17.714,
    fill: "#89A8F8",
    rx: 1.714
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cta-communities_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 43.429a5.714 5.714 0 0 0-5.714 5.714v28A5.714 5.714 0 0 0 20 82.857h7.429v7.429l8.857-7.429h26A5.714 5.714 0 0 0 68 77.143v-28a5.714 5.714 0 0 0-5.714-5.714H20Z"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 43.429,
    height: 3.429,
    x: 19.429,
    y: 61.143,
    fill: "#E6E9ED",
    rx: 1.714
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 43.429,
    height: 3.429,
    x: 19.429,
    y: 69.143,
    fill: "#E6E9ED",
    rx: 1.714
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 3.429,
    x: 19.429,
    y: 53.143,
    fill: "#BED1FF",
    rx: 1.714
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "cta-communities_svg__a",
    width: 73.714,
    height: 66.857,
    x: 4.286,
    y: 41.429,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 6,
    result: "effect1_dropShadow_4_180"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4_180",
    result: "shape"
  })))));
};
export { SvgCtaCommunities as ReactComponent };
export default "data:image/svg+xml;base64,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";